import { jsx as e, jsxs as k } from "react/jsx-runtime";
import { Button as B } from "@zapier/design-system-beta";
import { GoogleSSOButton as b } from "../GoogleSSOButton/GoogleSSOButton.es.js";
import { ShareButton as f } from "../ShareButton/ShareButton.es.js";
import { TryTemplateButton as T } from "../TryTemplateButton/TryTemplateButton.es.js";
import { TemplateBookmarkButton as y } from "../TemplateBookmarkButton/TemplateBookmarkButton.es.js";
import { Icon as u } from "@zapier/design-system";
import { Suspense as z } from "react";
const S = "_buttons_6775a_1", A = {
  buttons: S
};
var E = function(t) {
  var i, r, s, o = t.template, n = t.isLoggedIn, m = t.align, p = m === void 0 ? "start" : m, g = t.hasBookmarking, d = t.templateBookmarkActions, c = t.tryTemplateActions, a = t.buttonSize, v = n && g, l = (r = (i = o.products) === null || i === void 0 ? void 0 : i.items) !== null && r !== void 0 ? r : [], h = l.length === 1 && ((s = l[0]) === null || s === void 0 ? void 0 : s.slug) === "zaps";
  return /* @__PURE__ */ e(z, { children: /* @__PURE__ */ k("div", { className: A.buttons, style: { justifyContent: p }, children: [
    v && /* @__PURE__ */ e(y, { id: o.id, slug: o.slug, isZapTemplate: h, buttonVariant: "button", templateBookmarkActions: d }),
    n && /* @__PURE__ */ e(f, { slug: o.slug }),
    !n && /* @__PURE__ */ e(b, { size: a, slug: o.slug, children: "Continue with Google" }),
    /* @__PURE__ */ e(T, { component: B, slug: o.slug, products: l, iconStart: n ? /* @__PURE__ */ e(u, { name: "formAdd", size: 16 }) : null, iconEnd: n ? null : /* @__PURE__ */ e(u, { name: "arrowBigRight", size: 20 }), webIntentUrl: o.webIntentUrl, tryTemplateActions: c, size: a, children: n ? "Try it" : "Use this template" })
  ] }) });
};
export {
  E as TemplateCTAs
};
//# sourceMappingURL=TemplateCTAs.es.js.map
